import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import i18n from 'i18next';

import { Modal, Icon, Button } from 'modules/Core/Common';
import * as S from './BatchExportModal.styles';

const BatchExportModal = ({ isOpen, isLoading, onExportAgain, onDone }) => {
  const theme = useTheme();

  return (
    <Modal
      width="500"
      maxHeight="569"
      background={theme.config.colors.light}
      isOpen={isOpen}
      setIsOpen={isLoading ? undefined : onDone}
      offCloseOnOverlayClick
    >
      <S.Container>
        <S.ModalHeader>
          {isLoading ? (
            <S.LoadingIconBox>
              <Icon name="time" color={theme.config.colors.primary} size={32} />
            </S.LoadingIconBox>
          ) : (
            <S.IconBox>
              <Icon name="time" color={theme.config.colors.green} size={32} />
            </S.IconBox>
          )}
          <S.Title>
            {isLoading
              ? i18n.t('commons.modal-export.loading.title', {
                  defaultValue: 'Exporting...',
                })
              : i18n.t('commons.modal-export.success.email-sent')}
          </S.Title>
          <S.Description>
            {isLoading ? (
              i18n.t('commons.modal-export.loading.description', {
                defaultValue: 'Please wait while we process your request.',
              })
            ) : (
              <>
                {i18n.t('commons.modal-export.success.being-prepared')}
                <br />
                {i18n.t('commons.modal-export.success.you-receive-email')}
              </>
            )}
          </S.Description>
        </S.ModalHeader>

        {!isLoading && (
          <S.ModalFooter>
            <Button transparent medium onClick={onExportAgain}>
              {i18n.t('commons.modal-export.success.export-again')}
            </Button>
            <Button medium onClick={onDone}>
              {i18n.t('commons.modal-export.success.done')}
            </Button>
          </S.ModalFooter>
        )}
      </S.Container>
    </Modal>
  );
};

BatchExportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onExportAgain: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

BatchExportModal.defaultProps = {
  isLoading: false,
};

export default BatchExportModal;
